<template>
  <div></div>
</template>

<script>
import { wencesApi } from "@/api/wencesApi";

export default {
  name: "CustomJavaScript",
  data() {
    return {
      customJavaScript: "",
    };
  },
  async created() {
    await this.loadCustomJavaScript();
  },
  mounted() {
    // Ejecutar después de que Vue haya montado el componente
    this.$nextTick(() => {
      // Esperar un poco más para asegurar que todo esté cargado
      setTimeout(() => {
        this.executeCustomScript();
      }, 100);
    });
  },
  methods: {
    shouldSkipExecutionForCurrentRoute() {
      const path = this.$route?.path || "";
      const publicAuthPaths = ["/login", "/register", "/recoverpassword"];
      return publicAuthPaths.some((publicPath) => path.startsWith(publicPath));
    },
    async loadCustomJavaScript() {
      try {
        const response = await wencesApi.get("/api/settings");
        if (response.data.success && response.data.data) {
          this.customJavaScript = response.data.data.customJavaScript || "";
        }
      } catch (error) {
        console.error("Error loading custom JavaScript:", error);
      }
    },
    executeCustomScript() {
      if (this.shouldSkipExecutionForCurrentRoute()) {
        console.log(
          "[CustomJavaScript] ejecución omitida en ruta pública de auth:",
          this.$route?.path
        );
        return;
      }

      if (!this.customJavaScript || this.customJavaScript.trim() === "") {
        console.log("No hay JavaScript personalizado para ejecutar");
        return;
      }

      console.log(
        "Ejecutando JavaScript personalizado al final de la carga..."
      );

      try {
        // Reemplazar DOMContentLoaded con una función que se ejecute inmediatamente
        let scriptContent = this.customJavaScript;

        // Si el script contiene DOMContentLoaded, lo reemplazamos con una ejecución inmediata
        if (
          scriptContent.includes('document.addEventListener("DOMContentLoaded"')
        ) {
          console.log(
            "Detectado DOMContentLoaded, convirtiendo a función inmediata"
          );
          scriptContent = scriptContent
            .replace(
              /document\.addEventListener\("DOMContentLoaded",\s*\(\)\s*=>\s*\{/g,
              "(function() {"
            )
            .replace(
              /document\.addEventListener\("DOMContentLoaded",\s*function\(\)\s*\{/g,
              "(function() {"
            );

          // Cerrar la función al final
          if (
            !scriptContent.includes("});") ||
            scriptContent.split("});").length === 2
          ) {
            scriptContent = scriptContent.replace(/\}\);?\s*$/, "})();");
          }
        }


        // Ejecutar el script
        eval(scriptContent);
        console.log(
          "JavaScript personalizado ejecutado correctamente al final de la carga"
        );
      } catch (error) {
        console.error("Error ejecutando JavaScript personalizado:", error);
      }
    },
  },
  watch: {
    customJavaScript() {
      // Re-ejecutar cuando cambie el script, al final de la carga
      this.$nextTick(() => {
        setTimeout(() => {
          this.executeCustomScript();
        }, 1000);
      });
    },
  },
};
</script>

<style>
/* Custom JavaScript component styles */
</style>
